import React, { useState, useEffect } from 'react';
import { Navigate, useLocation, Outlet, useOutletContext } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { Box, CircularProgress, Typography } from '@mui/material';

const RequireAdmin = () => {
    const { currentUser } = useAuth();
    const outletContext = useOutletContext();
    const [isAdmin, setIsAdmin] = useState(null);
    const [loading, setLoading] = useState(true);
    let location = useLocation();

    useEffect(() => {
        const checkAdminRole = async () => {
            if (!currentUser) {
                setIsAdmin(false);
                setLoading(false);
                return;
            }

            try {
                // Get the ID token result which includes custom claims
                const tokenResult = await currentUser.getIdTokenResult(true);
                const role = tokenResult.claims.role;

                // Check if user has admin role
                setIsAdmin(role === 'admin');
            } catch (error) {
                console.error('Error checking admin role:', error);
                setIsAdmin(false);
            } finally {
                setLoading(false);
            }
        };

        checkAdminRole();
    }, [currentUser]);

    if (loading) {
        return (
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%'
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    if (!currentUser) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (!isAdmin) {
        return (
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    width: '100%'
                }}
            >
                <Typography variant="h5" color="error" gutterBottom>
                    Access Denied
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    You need admin privileges to access this page.
                </Typography>
            </Box>
        );
    }

    return <Outlet context={outletContext} />;
};

export default RequireAdmin;
